"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _HalflingIcon = _interopRequireDefault(require("./HalflingIcon"));
var _default = (0, _styledComponents["default"])(_HalflingIcon["default"]).withConfig({
  displayName: "Minus",
  componentId: "sc-1tl221b-0"
})(["background-position:right 1813px;"]);
exports["default"] = _default;
//# sourceMappingURL=Minus.js.map